import { request } from './_core'

// ── Sessions ─────────────────────────────────────────────────

export interface GameSession {
  id:           string
  activitySlug: string
  status:       'COMPLETED' | 'ABANDONED' | 'STARTED'
  difficulty:   string
  mode:         string | null
  score:        number | null
  moves:        number | null
  durationMs:   number | null
  startedAt:    string
  completedAt:  string | null
  createdAt:    string
}

export interface SubmitSessionParams {
  activitySlug:  string
  status:        'COMPLETED' | 'ABANDONED'
  difficulty:    'easy' | 'medium' | 'hard'
  mode?:         string
  durationMs?:   number
  moves?:        number
  pairsTotal?:   number
  pairsMatched?: number
  themeId?:      number
}

export interface CompleteSessionParams {
  sessionId:    string
  durationMs?:  number
  moves?:       number
  pairsTotal?:  number
  pairsMatched?:number
  mode?:        string
  themeId?:     number
}

export const sessions = {
  start: (activitySlug: string, difficulty: 'easy' | 'medium' | 'hard', mode?: string) =>
    request<{ sessionId: string }>('/sessions/start', {
      method: 'POST',
      body:   JSON.stringify({ activitySlug, difficulty, mode }),
    }),

  complete: (data: CompleteSessionParams) =>
    request<GameSession>('/sessions/complete', {
      method: 'POST',
      body:   JSON.stringify(data),
    }),

  submit: (data: SubmitSessionParams) =>
    request<GameSession>('/sessions', {
      method: 'POST',
      body:   JSON.stringify(data),
    }),

  list: (params?: { activitySlug?: string; limit?: number; cursor?: string }) => {
    const qs = params ? '?' + new URLSearchParams(params as Record<string, string>).toString() : ''
    return request<{ items: GameSession[]; nextCursor: string | null; hasMore: boolean }>(`/sessions${qs}`)
  },
}
